import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { name: '作品集', path: '/category/works' },
      { name: '资料档案', path: '/category/profile' },
      { name: '最新动态', path: '/category/news' },
      { name: '精选图集', path: '/category/gallery' },
    ],
  },
  {
    title: '社区互动',
    links: [
      { name: '粉丝社区', path: '/category/community' },
      { name: '深度访谈', path: '/category/interviews' },
      { name: '关于我们', path: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: '作品合集', path: '/category/works' },
      { name: '入门指南', path: '/article/anzai-rara-classic-works-top10' },
      { name: '粉丝攻略', path: '/article/anzai-rara-fan-community-guide' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                安斋拉拉主题站
              </Link>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                全方位主题落地页，汇聚安斋拉拉最全作品、资料、动态与粉丝社区，带你深度了解她的魅力。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">{group.title}</h4>
                <ul className="space-y-2">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 安斋拉拉主题站. 本站为非官方粉丝信息聚合平台，所有内容仅供学习交流。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-sm" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-sm" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-sm" rel="nofollow">
                <i className="ri-twitter-x-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}